import type { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import type { Vue } from 'vue/types/vue';

import { toTokenArray } from '@/helpers/convert';

const layout: ThisTypedComponentOptionsWithRecordProps<
  Vue,
  {},
  LayoutMixinMethods,
  LayoutMixinComputed,
  {}
> = {
  methods: {
    addRootClass() {
      return toggleRootClass(true, this.rootClass);
    },
    removeRootClass() {
      return toggleRootClass(false, this.rootClass);
    },
  },
  activated() {
    this.addRootClass();
  },
  beforeDestroy() {
    this.removeRootClass();
  },
  deactivated() {
    this.removeRootClass();
  },
  mounted() {
    this.addRootClass();
  },
};

export default layout;

export interface LayoutMixin {
  /**
   * The CSS classes which are added to the root element while the layout is active.
   */
  rootClass?: string | readonly string[] | null;

  /**
   * Adds the layout's root class(es) to the root HTML element.
   */
  addRootClass(): void;
  /**
   * Removes the layout's root class(es) from the root HTML element.
   */
  removeRootClass(): void;
}

export interface LayoutMixinComputed extends Pick<LayoutMixin, 'rootClass'> {}

export interface LayoutMixinMethods extends Pick<LayoutMixin, 'addRootClass' | 'removeRootClass'> {}

function toggleRootClass(add: boolean, rootClasses: any): void {
  const classes = toTokenArray(rootClasses);
  if (classes.length) {
    document.documentElement.classList[add ? 'add' : 'remove'](...classes);
  }
}
